import { Injectable } from '@angular/core';
import {Address} from "../order.service";

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor() { }


  public backendMapIsEmpty(map:any, errorMessage:string){
    if(!map || Object.keys(map).length<1){
      throw new Error(errorMessage);
    }
  }

  /**
   * Localizáció validálására alkalmas
   * @param localizationObject localizations objektum
   * @param attributeList tulajdonságok listája, melyet ellenőrizni kell. pl : ["name","description"]
   */
  public validateLocalizations(localizationObject, attributeList: string[]){
    Object.values<any>(localizationObject).forEach(localization => {
      attributeList.forEach(attribute => {
        if(localization[attribute] == null || localization[attribute] == undefined || localization[attribute].length<1){
          throw new Error("error.localization.required."+attribute);
        }
      })
    });
  }

  /**
   * Megvizsgálja a @value értéket, hogy ki van-e töltve, ha nincs, akkor @errorMessage hibát dob
   * @param value
   * @param errorMessage
   */
  public required(value, errorMessage){
    if(value == null || value.length == 0 || value == {}){
      throw new Error(errorMessage)
    }
  }

  /**
   * Az @object összes olyan tulajdonságát megvizsgálja, mely szerepel az @attributeList-ben
   * @param object
   * @param attributeList
   * @param modelName - vizsgált objektum neve, csak a hibaüzenethez kell
   */
  public allRequired(object, attributeList, modelName){
    attributeList.forEach(attribute => {
      this.required(object[attribute],"error."+modelName+".required."+attribute)
    })
  }

  /**
   * Hashmap address listát validál
   * @param addressesObject
   * @param modelName - vizsgált objektum neve, csak a hibaüzenethez kell
   */
  public validateAddressList(addressesObject, modelName){
    Object.keys(addressesObject).forEach(key =>{
      this.validateAddress(addressesObject[key].address, modelName)
    });
  }

  /**
   * Egy Address model-t validál
   * @param address
   * @param modelName - vizsgált objektum neve, csak a hibaüzenethez kell
   */
  public validateAddress(address: Address, modelName){
    if((address.country == null || address.country.length<1) ||
        (address.city == null || address.city.length<1)||
        (address.addressType == null || address.addressType.length<1)||
        (address.address == null || address.address.length<1)||
        (address.houseNumber == null || address.houseNumber.length<1)||
        (address.zipCode == null || address.zipCode.length<1 || address.zipCode.length>4)||
        (address.latitude == null || address.latitude<1)||
        (address.longitude== null || address.longitude<1)
    ){
      throw new Error("error."+modelName+".address.invalid");
    }
  }
}
